// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"PrizesInfoCard_buttonWrapper__Su7qC","inviteButton":"PrizesInfoCard_inviteButton__v7Pa8"};